import { A } from '@solidjs/router';
import type { JSX } from 'solid-js';
import { Show } from 'solid-js';
import { orgHref } from '../lib/org';
import type { RepoActivity } from '../lib/repo-detail';
import { absolute, ago } from '../lib/time';
import { StatusPill, type StatusTone } from './StatusPill';

// One row of the Overview recent-activity feed (#195), in the spec §3.13
// timeline voice — links into its full /audit/:session_id view.

function outcomeTone(outcome: string | null): StatusTone {
  if (outcome === 'merged' || outcome === 'completed') return 'success';
  if (outcome === 'failed') return 'danger';
  if (outcome === 'escalated') return 'warning';
  return 'neutral';
}

export function ActivityRow(props: { row: RepoActivity }): JSX.Element {
  return (
    <li class="timeline__item">
      <span class="timeline__dot" aria-hidden="true" />
      <div class="timeline__summary">
        <div class="repo-activity__lead">
          <A class="timeline__title repo-activity__link" href={orgHref(`/audit/${props.row.id}`)}>
            {props.row.title}
          </A>
          <p class="timeline__meta">
            {props.row.action}
            {' · '}
            <time datetime={props.row.when} title={absolute(props.row.when)}>
              {ago(props.row.when)}
            </time>
          </p>
        </div>
        <Show when={props.row.outcome}>
          {(o) => <StatusPill tone={outcomeTone(o())}>{o()}</StatusPill>}
        </Show>
      </div>
    </li>
  );
}
